/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/api/wallet/manage/account/recommend/change": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 币种推荐修改
         * @description 币种推荐修改
         */
        post: operations["recommendChange"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/manage/account/init": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 初始化账户
         * @description 初始化账户所有支持的币种钱包
         */
        post: operations["init"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/currency/add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 增加货币类型
         * @description 增加货币类型
         */
        post: operations["add"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/withdraw": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 提现
         * @description 用户钱包提现
         */
        post: operations["createWalletCashierWithdraw"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/deposit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 充值
         * @description 用户钱包充值
         */
        post: operations["createWalletCashierDeposit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/crypto/withdraw": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 提现
         * @description 提现创建
         */
        post: operations["createCashierCryptoWithdraw"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/crypto/checkWithdrawParams": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 检查出款请求
         * @description 检查出款请求
         */
        post: operations["createCashierCryptoCheckWithdrawParams"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/account/setting/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 修改钱包账户设置
         * @description 修改钱包账户设置
         */
        post: operations["updateSetting"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/account/trade/transfer": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 转账 */
        post: operations["transfer"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/account/trade/transfer/merchant": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 商户转账 */
        post: operations["transferMerchant"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/account/trade/reversal": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 回退
         * @description 下注回退/结算回退
         */
        post: operations["reversal"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/account/trade/payment": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 支付 */
        post: operations["payment"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/account/order/transfer/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 转账订单分页查询 */
        post: operations["listTransfer"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/account/order/payment/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 支付订单分页查询 */
        post: operations["listPaymentOrder"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/operation-list/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 更新配置 */
        post: operations["updateConfig"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/operation-list/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 分页查询配置列表 */
        post: operations["configList"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/operation-list/add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 新增配置 */
        post: operations["addConfig"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/currency/recharge/recommend/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 充值金额推荐更新 */
        post: operations["updateRechargeRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/currency/recharge/recommend/open": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 充值金额推荐启用 */
        post: operations["openRechargeRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/currency/recharge/recommend/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 充值金额推荐列表 */
        post: operations["listRechargeRecommends"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/currency/recharge/recommend/delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 充值金额推荐删除 */
        post: operations["deleteRechargeRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/currency/recharge/recommend/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 新建充值金额推荐 */
        post: operations["createRechargeRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/currency/recharge/recommend/close": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 充值金额推荐禁用 */
        post: operations["closeRechargeRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/cashier/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 充提订单查询 */
        post: operations["orderList"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/account/transaction/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 账户流水 */
        post: operations["transactionList"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/account/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 账户列表 */
        post: operations["accountList"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/account/freezeOrUnFreeze": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 冻结解冻 */
        post: operations["frozenOrUnFrozen"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/token/getTokensByCurrency": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询币种的token信息
         * @description 查询币种的token信息
         */
        get: operations["getWalletTokenGetTokensByCurrency"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/manage/account/recommend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 币种推荐
         * @description 币种推荐
         */
        get: operations["recommend"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/manage/account/recommend/config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 币种推荐配置列表
         * @description 币种推荐配置列表
         */
        get: operations["recommendConfig"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/manage/account/info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 钱包列表
         * @deprecated
         * @description 币种钱包列表
         */
        get: operations["info"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/manage/account/balance": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 用户余额
         * @description 用户币种余额
         */
        get: operations["balance"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/currency/view": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取币种展示
         * @description 获取币种展示
         */
        get: operations["getView"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/currency/getRealTimeExchangeRate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取实时汇率
         * @description 获取USD-其余币种实时汇率
         */
        get: operations["getRealTimeExchangeRate"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/currency/getExchangeRate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取汇率
         * @description 获取USD-其余币种汇率
         */
        get: operations["getExchangeRate"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/currency/getAllCurrency": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取全部币种
         * @description 获取全部币种
         */
        get: operations["getAllCurrency"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getWithdrawOrder": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询提现订单
         * @description 根据订单号查询提现订单
         */
        get: operations["getWalletCashierGetWithdrawOrder"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getWithdrawOrderList": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询提现订单列表
         * @description 分页查询提现订单列表
         */
        get: operations["getWithdrawOrders"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getWithdrawMethods": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取币种支持的提现方式
         * @description 通过币种查询，返回币种对应的提现方式列表
         */
        get: operations["getWalletCashierGetWithdrawMethods"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getWithdrawKycInfoList": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取提现通道对应的kyc信息
         * @description 获取提现通道对应的kyc信息
         */
        get: operations["getWithdrawKycInfoList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getWithdrawFee": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取提现订单手续费
         * @description 获取提现订单手续费
         */
        get: operations["getWalletCashierGetWithdrawFee"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getLastUsedChannel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取最近一次操作成功的币种和通道
         * @description 获取推荐币种和通道
         */
        get: operations["getLastUsedChannel"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getLastUsedChannelAll": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取最近一次操作成功的币种和通道
         * @description 获取推荐币种和通道
         */
        get: operations["getLastUsedChannelAll"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getDepositOrder": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询充值订单
         * @description 根据订单号查询充值订单
         */
        get: operations["getWalletCashierGetDepositOrder"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getDepositOrderList": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询充值订单列表
         * @description 分页查询充值订单列表
         */
        get: operations["getDepositOrders"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getDepositMethods": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取币种支持的充值方式
         * @description 获取用户可充值方式列表
         */
        get: operations["getDepositMethodsByCurrency"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getDepositKycInfoList": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取存款通道对应的kyc信息
         * @description 获取存款通道对应的kyc信息
         */
        get: operations["getDepositKycInfoList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getDepositChannelAmounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取渠道充值金额推荐 */
        get: operations["getDepositChannelAmounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getBcDepositOrder": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询充值订单
         * @description 根据订单号查询充值订单
         */
        get: operations["getBcDepositOrder"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/crypto/getWithdrawFee": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取提现手续费
         * @description 获取提现手续费
         */
        get: operations["getCashierCryptoGetWithdrawFee"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/crypto/getDepositAddressByChain": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询充值地址
         * @description 查询充值地址
         */
        get: operations["getDepositAddressByChain"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/account/setting/get": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询钱包账户设置
         * @description 查询钱包账户设置
         */
        get: operations["getSetting"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/account/trade/getSettlementOrder": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询结算订单 */
        get: operations["getSettlementOrder"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/account/trade/getReversalOrder": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询回退订单 */
        get: operations["getReversalByRequestId"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/account/trade/getPaymentOrder": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询支付订单 */
        get: operations["getPaymentByRequestId"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/operation-list/detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 根据ID查询配置详情 */
        get: operations["configDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/currency/recharge/recommend/get": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 充值金额推荐详情 */
        get: operations["getRechargeRecommend"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/currency/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 币种查询 */
        get: operations["listCurrencys"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/currency/channel/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 渠道列表查询 */
        get: operations["listChannels"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/currency/channel/limit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 渠道限额查询 */
        get: operations["getChannelLimit"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/currency/channel/amounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 渠道金额推荐 */
        get: operations["getAmounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/cashier/currencys": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 币种查询 */
        get: operations["getCurrencys"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/account/types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 交易类型查询 */
        get: operations["getTypes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/wallet/operation-list/delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** 删除配置 */
        delete: operations["deleteConfig"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/currency/getAllViewCurrency": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取全部展示币种
         * @description 获取全部展示币种
         */
        get: operations["getAllViewCurrency"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/record/transactionRecord/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 流水记录分页查询
         * @description 分页查询用户交易流水记录
         */
        get: operations["getRecordTransactionRecordList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/manage/account/recommend/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 币种推荐列表
         * @description 币种推荐列表
         */
        get: operations["getAccountRecommendList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/credit/repay": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 信用还款
         * @description 用户信用还款
         */
        post: operations["createWalletCreditRepay"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/credit/info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询授信账户信息 */
        get: operations["getWalletCreditInfo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/credit/transaction/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 授信流水分页查询 */
        get: operations["getCreditTransactionList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/credit/bills": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 账单列表
         * @description 含已出账账单 + 当月未出账
         */
        get: operations["getWalletCreditBills"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/credit/bill/detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 账单详情
         * @description 指定账期明细列表，每条含账期与周期（仅年月）
         */
        get: operations["getCreditBillDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/credit/transaction/detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 流水详情
         * @description orderId指定流水详情
         */
        get: operations["getCreditTransactionDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getDepositCurrency": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取充值币种
         * @description 使用的币种
         */
        get: operations["getWalletCashierGetDepositCurrency"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/crypto/getWithdrawAddressByChain": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询提现地址簿地址
         * @description 查询提现地址簿地址
         */
        get: operations["getCashierCryptoGetWithdrawAddressByChain"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/cashier/getWithdrawCurrency": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取提现币种
         * @description 使用的币种
         */
        get: operations["getWalletCashierGetWithdrawCurrency"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/trade/vault/withdraw": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 转出保险箱
         * @description 从保险箱转出到主余额
         */
        post: operations["createTradeVaultWithdraw"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/trade/vault/deposit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 转入保险箱
         * @description 从主余额转入保险箱
         */
        post: operations["createTradeVaultDeposit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/manage/account/vault/records": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 保险箱资金转入转出记录
         * @description 分页查询保险箱转入转出的记录
         */
        get: operations["getAccountVaultRecords"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/wallet/account/config/bet-limit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Query betting limit configuration
         * @description Compatible with original bonus configuration (minBet/minBetOdds/maxBet), and returns credit account maximum bet creditMaxBet
         */
        get: operations["getAccountConfigBetLimit"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        SingleResponseVoid: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: Record<string, never>;
        };
        SingleResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: Record<string, never>;
        };
        CurrencyRecommendChangeRequest: {
            /** @description 账户类型 */
            accountType: string;
            /** @description 币种 */
            currencyCode: string;
            /**
             * Format: int32
             * @description 币种类型 0:法币 1:加密货币
             */
            currencyType: number;
            /**
             * Format: int32
             * @description 状态 1:添加 0:删除
             */
            status: number;
        };
        /** @description 初始化账户请求体 */
        AccountInitReq: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /**
             * @description 账户类型
             * @enum {string}
             */
            accountType: "BALANCE";
            /** @description 用户ip */
            ip?: string;
        };
        SingleResponseBoolean: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: boolean;
        };
        /** @description 币种添加请求体 */
        CurrencyAddReq: {
            /** @description 币种的ISO字母代码，具有唯一性 */
            currencyCode: string;
            /** @description 币种的全称 */
            currencyName: string;
            /**
             * @description 币种类型：FIAT-法币, CRYPTO-加密货币
             * @enum {string}
             */
            currencyType: "FIAT" | "CRYPTO";
            /** @description 币种的货币符号 */
            symbol: string;
        };
        /** 提现请求DTO */
        WithdrawRequest: {
            /** 币种 */
            currency: string;
            /**
             * 提现渠道
             * Format: int32
             */
            channelId: number;
            /** 提现金额 */
            amount: number;
            /** kyc相关信息 */
            kycItem?: {
                [key: string]: string;
            };
        };
        SingleResponseWithdrawResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["WithdrawResponse"];
        };
        /** 创建提现订单响应DTO */
        WithdrawResponse: {
            /** 订单id */
            orderId: string;
            /** 支付渠道的交易号 */
            tradeNo: string;
            /** 手续费 */
            fee: number;
            /**
             * 订单状态
             * Format: int32
             */
            status: number;
        };
        /** 充值请求DTO */
        DepositRequest: {
            /** 币种 */
            currency: string;
            /**
             * 支付渠道
             * Format: int32
             */
            channelId: number;
            /** 充值金额 */
            amount: number;
            /** 用户KYC相关信息 */
            kycItem?: {
                [key: string]: string;
            };
            /** 营销活动 campaignId，可选，成功后将随 Kafka 充值消息透传 */
            campaignId?: string;
        };
        /** Create Deposit Order Response DTO */
        DepositResponse: {
            /** Order ID */
            orderId: string;
            /** Payment channel transaction number */
            tradeNo: string;
            /** Method */
            method: string;
            /** Order amount */
            orderAmount: number;
            /**
             * Order expiration time
             * Format: int64
             */
            expiredTime: number;
            /**
             * Order status: 0-Init, 1-Paying, 2-Success, 3-Failed, 4-Cancelled, 5-Expired
             * Format: int32
             */
            status: number;
            /** Failure code */
            failCode: string;
            /** Failure reason */
            failReason: string;
            /** Provider */
            fiatProvider: string;
            /** Channel */
            channel: string;
            /** Channel name */
            channelName: string;
            /** Completion time (available in final state) */
            completedTime: string;
            /**
             * Order creation time
             * Format: int64
             */
            createTime: number;
            /**
             * Payment mode: 0-Web payment, 2-In-app payment (QR code/Bank info), 6-UTR check mode
             * Format: int32
             */
            mode: number;
            payInfo: components["schemas"]["PayInfo"];
        };
        /** Payment data */
        PayInfo: {
            /** One-time verification code */
            opt: string;
            /** Instruction type */
            instruction: string;
            /** Dynamic script load payToken for payment */
            payToken: string;
            postUrl: string;
            postData: string;
            postType: string;
            /** Payment URL mode=0 */
            walletUrl: string;
            /** Payment card number */
            card: string;
            /** QR code mode=2 */
            qrCode: string;
            /** QR code content mode=2 */
            qrCodeContent: string;
            /** Payment info mode=2 (may include receiving bank, payee, account number, branch, etc.) as string array */
            payList: string;
            /** Security code */
            securityCode: string;
        };
        SingleResponseDepositResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["DepositResponse"];
        };
        /** 提现创建请求VO */
        CryptoWithdrawCreateRequest: {
            /** 合约 */
            tokenId?: string;
            /** 币种 */
            currencyName: string;
            /** 链 */
            chain: string;
            /** 提现金额 */
            amount: number;
            /** 提现地址 */
            withdrawAddr: string;
            /** 提现 memo */
            withdrawMemo?: string;
        };
        CryptoWithdrawCreateResponse: {
            /** 订单id */
            orderId: string;
            /** Format: int32 */
            status: number;
            fee: number;
        };
        SingleResponseCryptoWithdrawCreateResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CryptoWithdrawCreateResponse"];
        };
        /** 提现校验请求DTO */
        CryptoWithdrawSubmitCheckRequest: {
            /** 合约 */
            tokenId: string;
            /** 币种 */
            currencyName: string;
            /** 链 */
            chain: string;
            /** 提现金额 */
            amount: number;
            /** BZ平台手续费金额 */
            merchantFee: number;
            /** 提现渠道手续费金额 */
            channelFee: number;
            /** 提现地址 */
            withdrawAddr: string;
            /** 提现 memo */
            withdrawMemo: string;
        };
        /** 提现参数检查结果 */
        CryptoWithdrawSubmitCheckResponse: {
            /** 地址是否有效 */
            validAddr: boolean;
            /** 手续费是否正确 */
            validFee: boolean;
            /** 余额是否充足 */
            validBalance: boolean;
            /** 验证失败信息 */
            validMsg: string;
            /**
             * 风险等级
             * Format: int32
             */
            riskLevel: number;
            /** 风险提示信息 */
            riskMsg: string;
        };
        SingleResponseCryptoWithdrawSubmitCheckResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CryptoWithdrawSubmitCheckResponse"];
        };
        /** @description 账户偏好设置更新请求 */
        AccountPreferenceSettingUpdateRequest: {
            /** @description 账户类型 固定写死: BALANCE */
            accountType: string;
            /** @description 展示币种 */
            showCurrency?: string;
            /**
             * Format: int32
             * @description 虚拟币是否展示全称 1:是 2:否
             */
            cryptoShowFullCurrency?: number;
        };
        AccountTransferRequest: {
            requestId: string;
            /** Format: int64 */
            userId: number;
            /** Format: int64 */
            targetUserId: number;
            accountType: string;
            currencyCode: string;
            amount: string;
        };
        AccountTransferResponse: {
            orderId: string;
        };
        SingleResponseAccountTransferResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["AccountTransferResponse"];
        };
        AccountTransferMerchantRequest: {
            requestId: string;
            merchantId: string;
            /** Format: int64 */
            targetUserId: number;
            accountType: string;
            currencyCode: string;
            amount: string;
        };
        /** @description 账户回退请求体 */
        AccountReversalRequest: {
            /**
             * @description 请求ID
             * @example REQ123456789
             */
            requestId: string;
            /**
             * @description 回退类型
             * @enum {string}
             */
            reversalType: "BET_REVERSAL" | "SETTLEMENT_REVERSAL";
            /**
             * @description 原始订单号
             * @example ORDER123456789
             */
            originalOrderId: string;
            /**
             * @description 回退金额 [不传: 金额按订单维度逆向 传: 回退传递的金额]
             * @example 100.0
             */
            amount?: string | null;
        };
        AccountReversalResponse: {
            orderId: string;
        };
        SingleResponseAccountReversalResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["AccountReversalResponse"];
        };
        AccountPaymentRequest: {
            requestId: string;
            /** Format: int64 */
            userId: number;
            accountType: string;
            currencyCode: string;
            amount: string;
            merchantId: string;
        };
        AccountPaymentResponse: {
            orderId: string;
        };
        SingleResponseAccountPaymentResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["AccountPaymentResponse"];
        };
        AccountTransferListRequest: {
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            pageIndex?: number;
            orderBy?: string;
            orderDirection?: string;
            groupBy?: string;
            needTotalCount?: boolean;
            /** Format: int64 */
            userId: number;
            accountType: string;
            currencyCode: string;
            /** Format: int32 */
            offset?: number;
        };
        AccountTransferInfoResponse: {
            orderId: string;
            transferType: string;
            /** Format: int64 */
            userId: number;
            /** Format: int64 */
            accountId: number;
            currencyCode: string;
            amount: number;
            /** Format: int64 */
            createTime: number;
            /** Format: int64 */
            updateTime: number;
        };
        PageResponseAccountTransferInfoResponse: {
            /** Format: int32 */
            totalCount: number;
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            data: components["schemas"]["AccountTransferInfoResponse"][];
            /** Format: int32 */
            totalPages: number;
        };
        SingleResponsePageResponseAccountTransferInfoResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResponseAccountTransferInfoResponse"];
        };
        AccountPaymentListRequest: {
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            pageIndex?: number;
            orderBy?: string;
            orderDirection?: string;
            groupBy?: string;
            needTotalCount?: boolean;
            /** Format: int64 */
            userId: number;
            accountType: string;
            currencyCode: string;
            /** Format: int32 */
            offset?: number;
        };
        AccountPaymentInfoResponse: {
            orderId: string;
            requestId: string;
            /** Format: int64 */
            userId: number;
            currencyCode: string;
            amount: number;
            /** Format: int64 */
            createTime: number;
            /** Format: int64 */
            updateTime: number;
        };
        PageResponseAccountPaymentInfoResponse: {
            /** Format: int32 */
            totalCount: number;
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            data: components["schemas"]["AccountPaymentInfoResponse"][];
            /** Format: int32 */
            totalPages: number;
        };
        SingleResponsePageResponseAccountPaymentInfoResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResponseAccountPaymentInfoResponse"];
        };
        /** @description 钱包操作黑白名单配置更新请求 */
        AccountOperationListConfigUpdateRequest: {
            /**
             * Format: int64
             * @description 配置ID
             */
            id: number;
            /**
             * Format: int32
             * @description 状态：0-禁用,1-启用
             */
            status?: number;
            /** @description 备注 */
            remark?: string;
        };
        /** @description 账户操作黑白名单配置请求 */
        AccountOperationListConfigRequest: {
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description 操作类型：RECHARGE-充值,WITHDRAW-提现,TRANSFER-转账,PAYMENT-支付,REFUND-退款,EXCHANGE-兑换 */
            operationType: string;
            /**
             * Format: int32
             * @description 名单类型：1-白名单,2-黑名单
             */
            listType: number;
            /**
             * Format: int32
             * @description 状态：0-禁用,1-启用
             */
            status: number;
        };
        /** @description 钱包操作黑白名单配置响应 */
        AccountOperationListConfigResponse: {
            /**
             * Format: int64
             * @description 配置ID
             */
            id: number;
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description 操作类型 */
            operationType: string;
            /** @description 操作类型描述 */
            operationTypeDesc: string;
            /**
             * Format: int32
             * @description 名单类型：1-白名单,2-黑名单
             */
            listType: number;
            /** @description 名单类型描述 */
            listTypeDesc: string;
            /**
             * Format: int32
             * @description 状态：0-禁用,1-启用
             */
            status: number;
            /** @description 状态描述 */
            statusDesc: string;
            /** @description 备注 */
            remark: string;
            /**
             * Format: int64
             * @description 创建时间
             */
            createTime: number;
            /**
             * Format: int64
             * @description 更新时间
             */
            updateTime: number;
            /** @description 创建人 */
            createBy: string;
            /** @description 更新人 */
            updateBy: string;
        };
        PageResponseAccountOperationListConfigResponse: {
            /** Format: int32 */
            totalCount: number;
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            data: components["schemas"]["AccountOperationListConfigResponse"][];
            /** Format: int32 */
            totalPages: number;
        };
        SingleResponsePageResponseAccountOperationListConfigResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResponseAccountOperationListConfigResponse"];
        };
        /** @description 账户操作黑白名单配置新增请求 */
        AccountOperationListConfigAddRequest: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description 账户类型 固定写死: BALANCE */
            accountType: string;
            /** @description 操作类型：RECHARGE-充值,WITHDRAW-提现,TRANSFER-转账,PAYMENT-支付,REFUND-退款,EXCHANGE-兑换 */
            operationType: string;
            /**
             * Format: int32
             * @description 名单类型：1-白名单,2-黑名单
             */
            listType: number;
            /**
             * Format: int32
             * @description 状态：0-禁用,1-启用，默认为1
             */
            status?: number;
            /** @description 备注 */
            remark?: string;
        };
        /** @description 渠道配置列表 */
        RechargeRecommendChannel: {
            /**
             * Format: int32
             * @description 渠道id
             */
            channelId: number;
            /**
             * Format: int32
             * @description 金额推荐数量
             */
            recommendCount?: number;
            /** @description 金额推荐列表 */
            amounts: number[];
            /**
             * Format: int32
             * @description 最小金额
             */
            min: number;
            /**
             * Format: int32
             * @description 最大金额
             */
            max: number;
        };
        RechargeRecommendUpdateRequest: {
            /** @description 标题 */
            title?: string;
            /**
             * Format: int32
             * @description 货币类型,0:法币 1:加密货币
             */
            currencyType?: number;
            /** @description 货币币种 */
            currencyCode?: string;
            /** @description 渠道配置列表 */
            channelList?: components["schemas"]["RechargeRecommendChannel"][];
            /** @description 备注 */
            remark?: string;
            /**
             * Format: int64
             * @description id
             */
            id: number;
        };
        RechargeRecommendRequest: {
            /**
             * Format: int64
             * @description id
             */
            id: number;
        };
        RechargeRecommendListRequest: {
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            /** @description 标题 */
            title: string;
            /**
             * Format: int32
             * @description 货币类型,0:法币 1:加密货币
             */
            currencyType: number;
            /**
             * Format: int32
             * @description 状态,0:未启用 1:启用中
             */
            status: number;
        };
        PageResponseRechargeRecommendList: {
            /** Format: int32 */
            totalCount: number;
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            data: components["schemas"]["RechargeRecommendList"][];
            /** Format: int32 */
            totalPages: number;
        };
        RechargeRecommendList: {
            /**
             * Format: int64
             * @description id
             */
            id: number;
            /** @description 标题 */
            title: string;
            /** Format: int32 */
            status: number;
            /** Format: int32 */
            currencyType: number;
            currencyCode: string;
            /** Format: int64 */
            createTime: number;
            createBy: string;
        };
        SingleResponsePageResponseRechargeRecommendList: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResponseRechargeRecommendList"];
        };
        RechargeRecommendCreateRequest: {
            /** @description 标题 */
            title: string;
            /**
             * Format: int32
             * @description 货币类型,0:法币 1:加密货币
             */
            currencyType: number;
            /** @description 货币币种 */
            currencyCode: string;
            /** @description 渠道配置列表 */
            channelList: components["schemas"]["RechargeRecommendChannel"][];
            /** @description 备注 */
            remark: string;
        };
        AdminCashierListRequest: {
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            pageIndex?: number;
            /** Format: int64 */
            userId: number;
            currencyCode?: string;
            tradeType?: string;
            /** Format: int32 */
            status?: number;
        };
        AdminCashierListResponse: {
            /** Format: int64 */
            userId: number;
            orderId: string;
            currencyCode: string;
            channel: string;
            tradeType: string;
            tradeAmount: string;
            actualAmount: string;
            fee: string;
            status: string;
            /** Format: int64 */
            createTime: number;
            /** Format: int64 */
            updateTime: number;
        };
        PageResponseAdminCashierListResponse: {
            /** Format: int32 */
            totalCount: number;
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            data: components["schemas"]["AdminCashierListResponse"][];
            /** Format: int32 */
            totalPages: number;
        };
        SingleResponsePageResponseAdminCashierListResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResponseAdminCashierListResponse"];
        };
        AdminTransactionListRequest: {
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            pageIndex?: number;
            /** Format: int64 */
            userId: number;
            accountType: string;
            currencyCode?: string;
            transactionType?: string;
        };
        AdminTransactionListResponse: {
            /** Format: int64 */
            userId: number;
            accountId: string;
            currencyCode: string;
            orderId: string;
            transactionType: string;
            amount: string;
            beforeBalance: string;
            afterBalance: string;
            /** Format: int64 */
            createTime: number;
        };
        PageResponseAdminTransactionListResponse: {
            /** Format: int32 */
            totalCount: number;
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            data: components["schemas"]["AdminTransactionListResponse"][];
            /** Format: int32 */
            totalPages: number;
        };
        SingleResponsePageResponseAdminTransactionListResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResponseAdminTransactionListResponse"];
        };
        AdminAccountListRequest: {
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            pageIndex?: number;
            /** Format: int64 */
            userId: number;
            accountType?: string;
        };
        AdminAccountListResponse: {
            /** Format: int64 */
            userId: number;
            accountId: string;
            accountType: string;
            status: string;
            /** Format: int64 */
            createTime: number;
            /** Format: int64 */
            operateTime: number;
            currencyList: components["schemas"]["AdminCurrencyListResponse"][];
        };
        AdminCurrencyListResponse: {
            /** Format: int64 */
            userId: number;
            accountId: string;
            currencyCode: string;
            totalBalance: string;
            balance: string;
            frozenBalance: string;
        };
        PageResponseAdminAccountListResponse: {
            /** Format: int32 */
            totalCount: number;
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            data: components["schemas"]["AdminAccountListResponse"][];
            /** Format: int32 */
            totalPages: number;
        };
        SingleResponsePageResponseAdminAccountListResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResponseAdminAccountListResponse"];
        };
        AdminAccountFrozenOrUnRequest: {
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            pageIndex?: number;
            /** Format: int64 */
            accountId: number;
            operateType: string;
            reason: string;
        };
        /** 查询Token信息返回vo */
        CryptoTokenResponse: {
            /** 链 */
            chain: string;
            /** 与钱包系统交互需传的名称 */
            realChain: string;
            /** 链名称 */
            chainName: string;
            /** 链标签 */
            label: string;
            /** token全称 */
            tokenFullName: string;
            /** token 类型 native/erc20/trc20/trc10/bep20/spl/... */
            tokenType: string;
            /** tokenId */
            tokenId: string;
            /** 币种 */
            currency: string;
            /**
             * 精度
             * Format: int32
             */
            decimals: number;
            /** 地址类型 */
            addrTypes: {
                [key: string]: Record<string, never>;
            }[];
            /** 提现最小金额 */
            withdrawLimitAmount: number;
            /** 提现最大金额 */
            withdrawMaxAmount: number;
            /** 充值最小金额 */
            depositLimitAmount: number;
            /** 提现最小手续费 */
            minFee: number;
            /** 提现最大手续费 */
            maxFee: number;
            /** 区块浏览器 */
            blockExplorer: string;
            /** 查询交易路径 */
            queryTxPath: string;
            /** 查询代币路径 */
            queryTokenPath: string;
            /**
             * 状态 0 正常(充提都支持)；1 只支持充值； 2 只支持提现； 3 充提都不支持
             * Format: int32
             */
            status: number;
            /**
             * 充值确认次数
             * Format: int32
             */
            depositConfirmTimes: number;
            /**
             * 钱包管理模式 0 App 模式（托管钱包） 资金由平台或应用托管，用户不能直接控制私钥 1 OpenWallet 模式（开放钱包） 用户自己管理私钥，平台只负责签名或广播交易
             * Format: int32
             */
            walletVersion: number;
            /** 标签名称 */
            tagName: string;
        };
        SingleResponseListCryptoTokenResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CryptoTokenResponse"][];
        };
        /** @description 账户币种信息 */
        AccountCurrencyInfo: {
            /**
             * @description 货币编码
             * @example INR
             */
            currencyCode: string;
            /**
             * @description 货币全称
             * @example Indian Rupee
             */
            currencyFullName: string;
            /**
             * @description 货币符号
             * @example Indian Rupee
             */
            currencySymbol: string;
            /**
             * @description 总余额
             * @example 1000
             */
            totalBalance: number;
            /**
             * @description 可用余额
             * @example 1000
             */
            balance: number;
            /**
             * @description 冻结余额
             * @example 0
             */
            frozenBalance: number;
            /**
             * @description 币种类型
             * @example Fiat/Crypto
             */
            type: string;
        };
        CurrencyRecommendResponse: {
            /**
             * Format: int64
             * @description 用户ID
             * @example 10001
             */
            userId: number;
            /**
             * @description 账户类型
             * @enum {string}
             */
            accountType: "BALANCE";
            /**
             * Format: int64
             * @description 账户ID
             * @example 20001
             */
            accountId: number;
            /**
             * Format: int32
             * @description 账户状态
             * @example 1
             */
            status: number;
            /** @description 法币账户列表 */
            fiatCurrencyList: components["schemas"]["AccountCurrencyInfo"][];
            /** @description 虚拟货币账户列表 */
            cryptoCurrencyList: components["schemas"]["AccountCurrencyInfo"][];
        };
        SingleResponseCurrencyRecommendResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["CurrencyRecommendResponse"];
        };
        CurrencyRecommendConfigResponse: {
            /** @description 法币账户列表 */
            fiatCurrencyList: components["schemas"]["RecommendConfigInfo"][];
            /** @description 虚拟货币账户列表 */
            cryptoCurrencyList: components["schemas"]["RecommendConfigInfo"][];
        };
        /** @description 虚拟货币账户列表 */
        RecommendConfigInfo: {
            /**
             * @description 货币编码
             * @example INR
             */
            currencyCode: string;
            /**
             * @description 货币全称
             * @example Indian Rupee
             */
            currencyFullName: string;
            /**
             * Format: int32
             * @description 状态1:启用 0:禁用
             * @example 1
             */
            status: number;
        };
        SingleResponseCurrencyRecommendConfigResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["CurrencyRecommendConfigResponse"];
        };
        /** @description 账户信息响应体 */
        AccountInfoResp: {
            /**
             * Format: int64
             * @description 用户ID
             * @example 10001
             */
            userId: number;
            /**
             * @description 账户类型
             * @enum {string}
             */
            accountType: "BALANCE";
            /**
             * Format: int64
             * @description 账户ID
             * @example 20001
             */
            accountId: number;
            /**
             * Format: int32
             * @description 账户状态
             * @example 1
             */
            status: number;
            /** @description 账户币种列表 */
            accountCurrencyList: components["schemas"]["AccountCurrencyInfo"][];
        };
        SingleResponseAccountInfoResp: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["AccountInfoResp"];
        };
        SingleResponseString: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: string;
        };
        CurrencyViewResponse: {
            currencyCode: string;
            symbol: string;
        };
        SingleResponseListCurrencyViewResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["CurrencyViewResponse"][];
        };
        /** @description 币种汇率信息 */
        ExchangeRateResponse: {
            /** @description 币种 */
            currency: string;
            /**
             * Format: int32
             * @description 币种类型 0法币 1加密货币
             */
            currencyType: number;
            /** @description 买入币种对应的USD价格 */
            buyPrice: string;
            /** @description 卖出币种对应的USD价格 */
            sellPrice: string;
            /** @description 价格是否更新 true : 是 false : 否 */
            update: boolean;
            /**
             * Format: int64
             * @description 更新时间
             */
            updateTime: number;
        };
        SingleResponseMapStringExchangeRateResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: {
                [key: string]: components["schemas"]["ExchangeRateResponse"];
            };
        };
        /** @description 币种信息 */
        CurrencyVO: {
            currencyCode: string;
            aliasCurrencyName: string;
            fullName: string;
            /** Format: int64 */
            unitAmount: number;
            /**
             * Format: int32
             * @description 币种类型 0 表示法币（FIAT），1 表示加密货币
             */
            currencyType: number;
            /** Format: int32 */
            precisionUnit: number;
            /** @description 币种符号 */
            symbol: string;
            supportChains: string[];
            minBet: number;
            /** Format: int32 */
            zeroPlace: number;
            /** Format: int32 */
            showUnit: number;
        };
        SingleResponseListCurrencyVO: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["CurrencyVO"][];
        };
        /** 提现订单DTO */
        CashierWithdrawOrderResponse: {
            /**
             * 订单ID
             * Format: int64
             */
            id: number;
            /** 订单号 */
            orderId: string;
            /**
             * 用户ID
             * Format: int64
             */
            userId: number;
            /** 币种 */
            currency: string;
            /** 订单金额 */
            amount: number;
            /** 实际提现成功金额 */
            actualAmount: number;
            /** 渠道订单手续费 */
            channelFee: number;
            /** BZ平台手续费金额 */
            merchantFee: number;
            /** 余额提现订单号 */
            accountOrderId: string;
            /** 第三方订单号 */
            thirdOrderId: string;
            /** 提现渠道 */
            withdrawChannel: string;
            /** 渠道名称 */
            channelName: string;
            /** 订单信息-余额户号等 */
            orderInfo: string;
            /**
             * 状态：0初始化 1支付中 2成功 3失败 4已取消 5已过期
             * Format: int32
             */
            status: number;
            /**
             * 过期时间
             * Format: int64
             */
            expireTime: number;
            /**
             * 回调时间
             * Format: int64
             */
            callbackTime: number;
            /**
             * 创建时间
             * Format: int64
             */
            createTime: number;
            /**
             * 更新时间
             * Format: int64
             */
            updateTime: number;
        };
        SingleResponseCashierWithdrawOrderResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CashierWithdrawOrderResponse"];
        };
        IPageCashierWithdrawOrderResponse: {
            /** Format: int64 */
            size: number;
            /** Format: int64 */
            current: number;
            /** Format: int64 */
            total: number;
            records: components["schemas"]["CashierWithdrawOrderResponse"][];
            /**
             * Format: int64
             * @deprecated
             */
            pages: number;
        };
        SingleResponseIPageCashierWithdrawOrderResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["IPageCashierWithdrawOrderResponse"];
        };
        SingleResponseWithdrawMethodsResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["WithdrawMethodsResponse"];
        };
        /** 提现方式 */
        WithdrawMethod: {
            /**
             * 渠道id
             * Format: int32
             */
            channelId: number;
            provider: string;
            method: string;
            channel: string;
            supportCurrency: string;
            /** 渠道显示名称 */
            displayName: string;
            /** 渠道分类 */
            category: string;
            /** 亮色图标 */
            lightIconUrl: string;
            /** 暗色图标 */
            nightIconUrl: string;
            /** 最小限额 */
            minLimit: number;
            /** 最大限额 */
            maxLimit: number;
            /** 固定手续费 */
            feeFixed: number;
            /** 百分比手续费 */
            feePercent: number;
            /** 开始时间 */
            workStartTime: string;
            /** 结束时间 */
            workEndTime: string;
            /**
             * 过期时间：单位为秒
             * Format: int64
             */
            expiredTime: number;
            /**
             * KYC要求：0-不要求kyc 1-baseKyc 2-localKyc 3-phone 3-baseKyc+email 4-baseKyc+phone 5-advancedKyc 6-advancedKyc 7-advancedKyc+email 8-advancedKyc+phone+email
             * Format: int32
             */
            kycRequirement: number;
            /** 提示信息 */
            tipMessage: string;
            /** 预计到账时间 */
            avgMinutesSpent: string;
            /**
             * 标签 0:Last Used 1:Recommend
             * Format: int32
             */
            tag: number;
        };
        /** 用户可提现方式 */
        WithdrawMethodsResponse: {
            /** 按类别分组的提现方式列表 */
            withdrawMethodsByCurrency: {
                [key: string]: components["schemas"]["WithdrawMethod"][];
            };
        };
        /** 用户kyc信息 */
        KycInfoResponse: {
            /** 用户KYC列表 */
            item: components["schemas"]["UserItem"][];
        };
        SingleResponseKycInfoResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["KycInfoResponse"];
        };
        /** 用户KYC项 */
        UserItem: {
            /** 标签 */
            label: string;
            labelKey: string;
            /** 字段类型：text/select/map/select */
            type: string;
            /** 字段名称 ##提现用valueKey这个当作参数名 */
            valueKey: string;
            /** 统一key名称 ##充值用valueKey这个当作参数名 */
            commonKey: string;
            defaultValue: string;
            /** 是否隐藏 */
            hide: boolean;
            /** 是否只读 */
            readOnly: boolean;
            /** 验证时的依赖项， 根据依赖字段的值对当前字段进行验证 */
            parentValueKey: string;
            /** 选项列表 */
            options: string[];
            /** type为map_select时存在， map中的key是需要传递的值， value是展示的数据 */
            mapOptions: {
                [key: string]: string;
            }[];
            mapInfo: Record<string, never>;
            /** 校验模式列表 */
            validPatterns: components["schemas"]["ValidPattern"][];
            scriptRuleParamKey: Record<string, never>;
            scriptRuleStr: string;
        };
        /** 校验模式 */
        ValidPattern: {
            /** 分组 */
            validGroupName: string;
            /** 验证正则表达式，或1为定义的key，其他数据 */
            validKey: string;
            /** 验证正则表达式 */
            validRule: string;
            /** 验证消息 */
            validMessage: string;
        };
        SingleResponseBigDecimal: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: number;
        };
        SingleResponseUserLastUsedChannelResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["UserLastUsedChannelResponse"];
        };
        /** 用户最近一次充提的渠道返回vo */
        UserLastUsedChannelResponse: {
            /** 币种 */
            currencyCode: string;
            /**
             * 通道id - 法币返回
             * Format: int64
             */
            channelId: number;
            /** 链code - 虚拟币返回 */
            realChain: string;
        };
        /** 渠道详情 */
        ChannelDetail: {
            /** 币种 */
            currencyCode: string;
            /**
             * 通道id - 法币返回
             * Format: int64
             */
            channelId: number;
            /** 链code - 虚拟币返回 */
            realChain: string;
        };
        SingleResponseUserLastUsedChannelAllResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["UserLastUsedChannelAllResponse"];
        };
        /** 用户最近一次充提的渠道返回vo */
        UserLastUsedChannelAllResponse: {
            fiatDeposit: components["schemas"]["ChannelDetail"];
            cryptoDeposit: components["schemas"]["ChannelDetail"];
            fiatWithdraw: components["schemas"]["ChannelDetail"];
            cryptoWithdraw: components["schemas"]["ChannelDetail"];
        };
        /** 充值订单DTO */
        CashierDepositOrderResponse: {
            /** 订单号 */
            orderId: string;
            /** 三方订单号 */
            tradeNo: string;
            /**
             * 用户ID
             * Format: int64
             */
            userId: number;
            /** 币种 */
            currency: string;
            /**
             * 币种类型 0 FIAT 1 CRYPTO
             * Format: int32
             */
            currencyType: number;
            /** 订单金额 */
            amount: number;
            /** 实际充值成功金额 */
            actualAmount: number;
            /**
             * 状态：0初始化 1支付中 2成功 3失败 4已取消 5已过期
             * Format: int32
             */
            status: number;
            /**
             * 创建时间
             * Format: int64
             */
            createTime: number;
            /**
             * 回调时间
             * Format: int64
             */
            callbackTime: number;
            /** FIAT-充值渠道 */
            channel: string;
            /** 渠道名称 */
            channelName: string;
            /**
             * FIAT-过期时间
             * Format: int64
             */
            expireTime: number;
            /** CRYPTO-链 */
            chain: string;
            /** CRYPTO-交易地址 */
            blockAddress: string;
            /**
             * 支付模式 0:网页支付  2:站内支付(二维码/银行信息) 6:UTR 查单模式
             * Format: int32
             */
            mode: number;
            payInfo: components["schemas"]["PayInfo"];
        };
        SingleResponseCashierDepositOrderResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CashierDepositOrderResponse"];
        };
        IPageCashierDepositOrderResponse: {
            /** Format: int64 */
            size: number;
            /** Format: int64 */
            current: number;
            /** Format: int64 */
            total: number;
            records: components["schemas"]["CashierDepositOrderResponse"][];
            /**
             * Format: int64
             * @deprecated
             */
            pages: number;
        };
        SingleResponseIPageCashierDepositOrderResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["IPageCashierDepositOrderResponse"];
        };
        /** 充值方式信息 */
        DepositMethod: {
            /**
             * 渠道id
             * Format: int32
             */
            channelId: number;
            provider: string;
            method: string;
            channel: string;
            supportCurrency: string;
            /** 显示名称 */
            displayName: string;
            /** 类别 */
            category: string;
            /** 亮图标url */
            lightIconUrl: string;
            /** 暗图标url */
            nightIconUrl: string;
            /** 最小限额 */
            minLimit: number;
            /** 最大限额 */
            maxLimit: number;
            /** 固定手续费 */
            feeFixed: number;
            /** 百分比手续费 */
            feePercent: number;
            /** 开始时间 */
            workStartTime: string;
            /** 结束时间 */
            workEndTime: string;
            /**
             * 过期时间
             * Format: int64
             */
            expiredTime: number;
            /**
             * KYC要求：0-不要求kyc 1-baseKyc 2-localKyc 3-phone 3-baseKyc+email 4-baseKyc+phone 5-advancedKyc 6-advancedKyc 7-advancedKyc+email 8-advancedKyc+phone+email
             * Format: int32
             */
            kycRequirement: number;
            /**
             * 支付模式 0:网页进行支付 2:站内显示支付 6:UTR 查单模式
             * Format: int32
             */
            mode: number;
            /** 提示词 */
            tipMessage: string;
            /** 预计到账时间 */
            avgMinutesSpent: string;
            /**
             * 标签：0-Last used 1- Recommend
             * Format: int32
             */
            tag: number;
        };
        /** 用户可充值方式响应DTO */
        DepositMethodsResponse: {
            /** 按类别分组的充值方式列表 */
            depositMethodsByCurrency: {
                [key: string]: components["schemas"]["DepositMethod"][];
            };
        };
        SingleResponseDepositMethodsResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["DepositMethodsResponse"];
        };
        DepositChannelAmountsResponse: {
            amounts: number[];
        };
        SingleResponseDepositChannelAmountsResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["DepositChannelAmountsResponse"];
        };
        DepositQueryResponse: {
            tradeNo: string;
            merchantOrderNo: string;
            /** Format: int32 */
            channelId: number;
            provider: string;
            channel: string;
            method: string;
            /** Format: int32 */
            status: number;
            payInfo: components["schemas"]["PayInfo"];
            /** Format: int32 */
            mode: number;
            /** Format: int64 */
            createTime: number;
            currency: string;
            /** Format: int64 */
            expiredTime: number;
            failCode: string;
            failReason: string;
            orderAmount: number;
            receiveAmount: number;
            fee: number;
        };
        SingleResponseDepositQueryResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["DepositQueryResponse"];
        };
        /** 获取提现手续费返回VO */
        CryptoWithdrawFeeResponse: {
            /** @description 提现金额 */
            withdrawalAmount: number;
            /** @description 商户手续费 */
            merchantFee: number;
            /** @description 渠道手续费 */
            channelFee: number;
            /** @description 你将收到 */
            receive: number;
            /** 链 */
            chain: string;
            /** 手续费币种 */
            feeCurrencyName: string;
            /** 合约 */
            feeTokenId: string;
            /** 手续费 */
            fastFee: number;
            /** 手续费 */
            normalFee: number;
            /** 手续费 */
            lowFee: number;
        };
        SingleResponseCryptoWithdrawFeeResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CryptoWithdrawFeeResponse"];
        };
        /** 查询充值地址返回vo */
        QueryDepositAddressResponse: {
            /** 分配地址 */
            addr: string;
            /** 分配的memo */
            memo: string;
            /**
             * 次数
             * Format: int32
             */
            depositConfirmTimes: number;
        };
        SingleResponseQueryDepositAddressResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["QueryDepositAddressResponse"];
        };
        /** @description 账户偏好设置响应 */
        AccountPreferenceSettingResponse: {
            /** @description 展示币种 */
            showCurrency: string;
            /**
             * Format: int32
             * @description 虚拟币是否展示全称 1:是 2:否
             */
            cryptoShowFullCurrency: number;
        };
        SingleResponseAccountPreferenceSettingResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["AccountPreferenceSettingResponse"];
        };
        SingleResponseAccountOperationListConfigResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["AccountOperationListConfigResponse"];
        };
        RechargeRecommendResponse: {
            /** @description 标题 */
            title: string;
            /**
             * Format: int32
             * @description 货币类型,0:法币 1:加密货币
             */
            currencyType: number;
            /** @description 货币币种 */
            currencyCode: string;
            /** @description 渠道配置列表 */
            channelList: components["schemas"]["RechargeRecommendChannel"][];
            /** @description 备注 */
            remark: string;
        };
        SingleResponseRechargeRecommendResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["RechargeRecommendResponse"];
        };
        SingleResponseListString: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: string[];
        };
        ChannelListResponse: {
            /**
             * Format: int32
             * @description 渠道id
             */
            channelId: number;
            /** @description 分类 */
            category: string;
            /** @description 通道显示名称 */
            displayName: string;
            /** @description 通道provider */
            provider: string;
            /** @description 通道channel */
            channel: string;
            /** @description 通道方法 */
            method: string;
        };
        SingleResponseListChannelListResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["ChannelListResponse"][];
        };
        ChannelLimitResponse: {
            /**
             * Format: int32
             * @description 最小值
             */
            min: number;
            /**
             * Format: int32
             * @description 最大值
             */
            max: number;
        };
        SingleResponseChannelLimitResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["ChannelLimitResponse"];
        };
        SingleResponseListInteger: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: number[];
        };
        SingleResponseListCurrencyViewVO: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["CurrencyViewVO"][];
        };
        /** @description 展示币种信息 */
        CurrencyViewVO: {
            currencyCode: string;
            symbol: string;
            /** Format: int32 */
            zeroPlace: number;
            /** Format: int32 */
            showUnit: number;
        };
        SingleResponsePageResponseTransactionRecordResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["PageResponseTransactionRecordResponse"];
        };
        PageResponseTransactionRecordResponse: {
            /** Format: int32 */
            totalCount: number;
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            data: components["schemas"]["TransactionRecordResponse"][];
            /** Format: int32 */
            totalPages: number;
        };
        /** 资金流水 */
        TransactionRecordResponse: {
            /** 记录号 */
            orderId: string;
            /**
             * 时间
             * Format: int64
             */
            time: number;
            /** 类型 */
            type: string;
            /** 来源 */
            source: string;
            /** 订单号 */
            referenceId: string;
            /** 币种 */
            currencyCode: string;
            /** 订单金额 */
            amount: number;
            /** 余额-前 */
            balanceBefore: number;
            /** 余额-后 */
            balanceAfter: number;
        };
        SingleResponseRecommendResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["RecommendResponse"];
        };
        RecommendResponse: {
            cash: components["schemas"]["CashRecommendResponse"];
            bonus: components["schemas"]["BalanceRecommendResponse"];
            vault: components["schemas"]["VaultRecommendResponse"];
        };
        /** @description 现金账户 */
        CashRecommendResponse: {
            /**
             * Format: int32
             * @description 账户状态
             * @example 1
             */
            status: number;
            /** @description 法币账户列表 */
            fiatCurrencyList: components["schemas"]["AccountCurrencyInfo"][];
            /** @description 虚拟货币账户列表 */
            cryptoCurrencyList: components["schemas"]["AccountCurrencyInfo"][];
        };
        /** @description 奖金账户 */
        BalanceRecommendResponse: {
            /**
             * Format: int32
             * @description 账户状态
             * @example 1
             */
            status: number;
            /** @description 货币列表 */
            currencyList: components["schemas"]["AccountCurrencyInfo"][];
        };
        SingleResponseWithdrawFeeResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["WithdrawFeeResponse"];
        };
        /** 手续费信息 */
        WithdrawFeeResponse: {
            /** @description 提现金额 */
            withdrawalAmount: number;
            /** @description 商户手续费 */
            merchantFee: number;
            /** @description 渠道手续费 */
            channelFee: number;
            /** @description 你将收到 */
            receive: number;
        };
        CreditRepayRequest: {
            /** 账期 */
            billPeriod: string;
            /** 现金资产币种 */
            cashCurrencyList: string[];
            /** 信用资产币种 */
            creditCurrency: string;
            /** 还款金额 */
            amount?: string;
        };
        SingleResponseCreditRepayResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CreditRepayResponse"];
        };
        CreditRepayResponse: {
            orderId: string;
            referenceId: string;
            /** Format: int64 */
            createTime: number;
            paidWith: components["schemas"]["PaidWithResponse"][];
        };
        SingleResponseCreditAccountInfoResult: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CreditAccountInfoResult"];
        };
        /** @description 授信账户信息响应 */
        CreditAccountInfoResult: {
            /** @description 总授信余额 */
            totalBalance: number;
            /** @description 可用余额 */
            availableBalance: number;
            /** @description 已使用余额 */
            frozenBalance: number;
            /** @description 未还款总金额 */
            totalUnpaidAmount: number;
            /**
             * Format: int32
             * @description 还款状态 1:未还款 2:提醒还款 3:超期未还款
             */
            repaymentStatus: number;
            /**
             * Format: int64
             * @description 还款时间戳(毫秒)
             */
            repaymentTime: number;
            /** @description 账期 */
            billPeriod: string;
            /** @description 账户是否存在已出账账单 */
            hasIssuedBill: boolean;
            /** @description 是否为已出账单，true=已出账 false=未出账（当月未出账合成） */
            billed: boolean;
            /** @description 年份（由 billPeriod 前4位截取） */
            year: string;
            /** @description 账单周期开始（精确到日 yyyy-MM-dd），由 periodStart 时间戳转换 */
            periodStartDisplay: string;
            /** @description 账单周期结束（精确到日 yyyy-MM-dd），由 periodEnd 时间戳转换 */
            periodEndDisplay: string;
            /** @description 下一个账期开始日期（精确到日 yyyy-MM-dd），即当前账期下月1号 */
            nextPeriodStartDisplay: string;
            /**
             * Format: int32
             * @description 账户状态，参见 AccountStatusEnum：1-正常 0-冻结
             */
            accountStatus: number;
        };
        SingleResponsePageResponseCreditTransactionRecordResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["PageResponseCreditTransactionRecordResponse"];
        };
        PageResponseCreditTransactionRecordResponse: {
            /** Format: int32 */
            totalCount: number;
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            data: components["schemas"]["CreditTransactionRecordResponse"][];
            /** Format: int32 */
            totalPages: number;
        };
        /** 授信流水 */
        CreditTransactionRecordResponse: {
            /** 记录号 */
            orderId: string;
            /**
             * 时间
             * Format: int64
             */
            time: number;
            /** 类型 */
            type: string;
            /** 订单号 */
            referenceId: string;
            /** 订单金额 */
            amount: number;
            /** 余额-前 */
            balanceBefore: number;
            /** 余额-后 */
            balanceAfter: number;
        };
        PaidWith: {
            currency: string;
            cashAmount: string;
            creditAmount: string;
        };
        SingleResponseListBillListResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["BillListResponse"][];
        };
        /** @description 账单列表项 */
        BillListResponse: {
            /**
             * Format: int64
             * @description 账单主键（未出账时为 null）
             */
            id: number;
            /** @description 账期 yyyy-MM */
            billPeriod: string;
            /** @description 年份（由 billPeriod 前4位截取） */
            year: string;
            /** @description 账单周期开始（精确到日 yyyy-MM-dd），由 periodStart 时间戳转换 */
            periodStartDisplay: string;
            /** @description 账单周期结束（精确到日 yyyy-MM-dd），由 periodEnd 时间戳转换 */
            periodEndDisplay: string;
            /** @description 账单金额（本期应还/欠款） */
            amount: number;
            /** @description 已还款金额 */
            repayAmount: number;
            /** @description 状态：UNPAID-未还款, OVERDUE-已逾期, SETTLED-已结清, PENDING-未出账 */
            status: string;
            /**
             * Format: int64
             * @description 还款截止时间戳(毫秒)
             */
            repayTime: number;
            /** @description 是否已出账，true=已出账，false=当月未出账合成 */
            billed: boolean;
            /** @description 币种 */
            currencyCode: string;
        };
        SingleResponseListBillDetailResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["BillDetailResponse"][];
        };
        /** @description 账单详情单条 */
        BillDetailResponse: {
            /** @description 类型展示名，如 Bet Placed, Auto-Deduction (Deposit) */
            type: string;
            /** @description 参考ID/订单号 */
            referenceId: string;
            /** @description 金额（还款为负数） */
            amount: number;
            /**
             * Format: int64
             * @description 时间(毫秒)
             */
            time: number;
        };
        PaidWithResponse: {
            currency: string;
            cashAmount: string;
            creditAmount: string;
        };
        SingleResponseTransactionDetailResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["TransactionDetailResponse"];
        };
        /** @description 授信流水详情 */
        TransactionDetailResponse: {
            /** @description 类型展示名，如 Bet Placed, Auto-Deduction (Deposit) */
            type: string;
            /** @description 参考ID/订单号 */
            referenceId: string;
            /**
             * Format: int64
             * @description 时间(毫秒)
             */
            time: number;
            /** @description 金额信息 */
            paidWith: components["schemas"]["PaidWithResponse"][];
        };
        SingleResponseDepositCurrencyResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["DepositCurrencyResponse"];
        };
        DepositCurrencyResponse: {
            /** @description 币种列表 */
            currencyList: components["schemas"]["CurrencyInfo"][];
            /** @description 最近充值币种列表 */
            recentRechargeCurrencyList: components["schemas"]["CurrencyInfo"][];
        };
        /** @description 账户币种信息 */
        CurrencyInfo: {
            /**
             * @description 货币编码
             * @example INR
             */
            currencyCode: string;
            /**
             * @description 货币全称
             * @example Indian Rupee
             */
            currencyFullName: string;
            /**
             * @description 货币符号
             * @example Indian Rupee
             */
            currencySymbol: string;
        };
        SingleResponseWithdrawCurrencyResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["WithdrawCurrencyResponse"];
        };
        WithdrawCurrencyResponse: {
            /** @description 币种列表 */
            currencyList: components["schemas"]["WithdrawCurrencyInfo"][];
        };
        /** @description 账户币种信息 */
        WithdrawCurrencyInfo: {
            /**
             * @description 货币编码
             * @example INR
             */
            currencyCode: string;
            /**
             * @description 货币全称
             * @example Indian Rupee
             */
            currencyFullName: string;
            /**
             * @description 货币符号
             * @example Indian Rupee
             */
            currencySymbol: string;
            balance: number;
        };
        /** @description 保险箱转账请求 */
        AccountVaultTransferRequest: {
            /** @description 币种 */
            currency: string;
            /** @description 金额 */
            amount: number;
        };
        SingleResponsePageResponseAccountVaultOrderResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["PageResponseAccountVaultOrderResponse"];
        };
        PageResponseAccountVaultOrderResponse: {
            /** Format: int32 */
            totalCount: number;
            /** Format: int32 */
            pageSize: number;
            /** Format: int32 */
            pageIndex: number;
            data: components["schemas"]["AccountVaultOrderResponse"][];
            /** Format: int32 */
            totalPages: number;
        };
        /** @description 保险箱转账记录 */
        AccountVaultOrderResponse: {
            /** @description 订单号 */
            orderId: string;
            /** @description 交易类型 VAULT_DEPOSIT, VAULT_WITHDRAW */
            tradeType: string;
            /** @description 操作币种 */
            currencyCode: string;
            /**
             * Format: int32
             * @description 法币或加密货币：0=法币，1=加密货币
             */
            currencyType: number;
            /** @description 金额 */
            amount: number;
            /** @description 美元等值金额 */
            amountUsd: number;
            /** @description 交易前的总余额 */
            totalBalanceBefore: number;
            /** @description 交易后的总余额 */
            totalBalanceAfter: number;
            /**
             * Format: int64
             * @description 创建时间(毫秒级)
             */
            createTime: number;
        };
        /** @description 保险箱账户 */
        VaultRecommendResponse: {
            /**
             * Format: int32
             * @description 账户状态
             * @example 1
             */
            status: number;
            /** @description 法币账户列表 */
            fiatCurrencyList: components["schemas"]["AccountCurrencyInfo"][];
            /** @description 虚拟货币账户列表 */
            cryptoCurrencyList: components["schemas"]["AccountCurrencyInfo"][];
        };
        SingleResponseAccountBetLimitConfigResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["AccountBetLimitConfigResponse"];
        };
        /** @description Betting limit configuration (includes global bonus parameters and credit account maximum bet) */
        AccountBetLimitConfigResponse: {
            /** @description Minimum bet amount, USD */
            minBet: number;
            /** @description Minimum bet odds */
            minBetOdds: number;
            /** @description Maximum bet amount, USD */
            maxBet: number;
            /** @description Credit account maximum bet (account_currency.max_bet, consistent with credit currency; -1 means unlimited) */
            creditMaxBet: number;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    recommendChange: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CurrencyRecommendChangeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    init: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountInitReq"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    add: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CurrencyAddReq"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    createWalletCashierWithdraw: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["WithdrawRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseWithdrawResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    createWalletCashierDeposit: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description Client type /api All interfaces starting with will be restricted by gateway
                 *     Rules are as follows: [xx business]-[xx end]
                 *     BZ business:
                 *     1. Web end BZ-WEB
                 *     2. App end BZ-APP
                 *     3. Mini program end BZ-AAPLET
                 *     dev, test environment can use default value in swagger: SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DepositRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseDepositResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    createCashierCryptoWithdraw: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CryptoWithdrawCreateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCryptoWithdrawCreateResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    createCashierCryptoCheckWithdrawParams: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CryptoWithdrawSubmitCheckRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCryptoWithdrawSubmitCheckResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    updateSetting: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountPreferenceSettingUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    transfer: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountTransferRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAccountTransferResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    transferMerchant: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountTransferMerchantRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAccountTransferResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    reversal: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountReversalRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAccountReversalResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    payment: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountPaymentRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAccountPaymentResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    listTransfer: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountTransferListRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResponseAccountTransferInfoResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    listPaymentOrder: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountPaymentListRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResponseAccountPaymentInfoResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    updateConfig: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountOperationListConfigUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    configList: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountOperationListConfigRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResponseAccountOperationListConfigResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    addConfig: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountOperationListConfigAddRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    updateRechargeRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RechargeRecommendUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    openRechargeRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RechargeRecommendRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    listRechargeRecommends: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RechargeRecommendListRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResponseRechargeRecommendList"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    deleteRechargeRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RechargeRecommendRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    createRechargeRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RechargeRecommendCreateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    closeRechargeRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RechargeRecommendRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    orderList: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminCashierListRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResponseAdminCashierListResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    transactionList: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminTransactionListRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResponseAdminTransactionListResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    accountList: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminAccountListRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResponseAdminAccountListResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    frozenOrUnFrozen: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminAccountFrozenOrUnRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getWalletTokenGetTokensByCurrency: {
        parameters: {
            query: {
                /** @description 币种 */
                currency: string;
                /** @description 类型：0-充值deposit，1-提现withdrawal */
                type?: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListCryptoTokenResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    recommend: {
        parameters: {
            query: {
                accountType: "BALANCE";
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCurrencyRecommendResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    recommendConfig: {
        parameters: {
            query: {
                accountType: "BALANCE";
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCurrencyRecommendConfigResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    info: {
        parameters: {
            query: {
                accountType: "BALANCE";
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAccountInfoResp"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    balance: {
        parameters: {
            query: {
                /** @description 用户id */
                userId: number;
                /** @description 币种code */
                currency: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getView: {
        parameters: {
            query: {
                accountType: "BALANCE";
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListCurrencyViewResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getRealTimeExchangeRate: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapStringExchangeRateResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getExchangeRate: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapStringExchangeRateResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getAllCurrency: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListCurrencyVO"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getWalletCashierGetWithdrawOrder: {
        parameters: {
            query: {
                /** @description 订单号 */
                orderId: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCashierWithdrawOrderResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getWithdrawOrders: {
        parameters: {
            query?: {
                /** @description 币种 */
                currency?: string;
                /** @description 状态 1处理中 2成功 3失败 4已取消 5已过期 */
                status?: number;
                /** @description 开始时间 */
                startTime?: number;
                /** @description 结束时间 */
                endTime?: number;
                /** @description 页码 */
                pageNum?: number;
                /** @description 每页大小 */
                pageSize?: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseIPageCashierWithdrawOrderResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getWalletCashierGetWithdrawMethods: {
        parameters: {
            query: {
                /** @description 币种 */
                currency: string;
            };
            header?: {
                "Accept-Language"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseWithdrawMethodsResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getWithdrawKycInfoList: {
        parameters: {
            query: {
                /** @description 提现通道id */
                channelId: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseKycInfoResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getWalletCashierGetWithdrawFee: {
        parameters: {
            query: {
                /** @description 币种 */
                currency: string;
                /** @description 提现通道 */
                channelId: number;
                /** @description 金额 */
                amount: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseWithdrawFeeResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getLastUsedChannel: {
        parameters: {
            query: {
                /** @description 币种类型 0:法币 1:虚拟币 */
                currencyType: number;
                /** @description 操作类型 0:充值 1:提现 */
                type: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUserLastUsedChannelResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getLastUsedChannelAll: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUserLastUsedChannelAllResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getWalletCashierGetDepositOrder: {
        parameters: {
            query: {
                /** @description 订单号 */
                orderId: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCashierDepositOrderResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getDepositOrders: {
        parameters: {
            query?: {
                /** @description 币种 */
                currency?: string;
                /** @description 状态 0初始化 1充值中 2成功 3失败 4已取消 5已过期 */
                status?: number;
                /** @description 开始时间 */
                startTime?: number;
                /** @description 结束时间 */
                endTime?: number;
                /** @description 页码 */
                pageNum?: number;
                /** @description 每页大小 */
                pageSize?: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseIPageCashierDepositOrderResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getDepositMethodsByCurrency: {
        parameters: {
            query: {
                /** @description 币种 */
                currency: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseDepositMethodsResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getDepositKycInfoList: {
        parameters: {
            query: {
                /** @description 存款通道id */
                channelId: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseKycInfoResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getDepositChannelAmounts: {
        parameters: {
            query: {
                /** @description 币种 */
                currency: string;
                /** @description 渠道id */
                channelId: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseDepositChannelAmountsResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getBcDepositOrder: {
        parameters: {
            query: {
                /** @description 订单号 */
                thirdOrderId: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseDepositQueryResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getCashierCryptoGetWithdrawFee: {
        parameters: {
            query: {
                /** @description 币种 */
                currency: string;
                /** @description 链 */
                chain: string;
                /** @description tokenId */
                tokenId: string;
                /** @description 提现金额 */
                amount: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCryptoWithdrawFeeResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getDepositAddressByChain: {
        parameters: {
            query: {
                /** @description 币种 */
                currency: string;
                /** @description 链 */
                chain: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseQueryDepositAddressResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getSetting: {
        parameters: {
            query: {
                /** @description 固定写死: BALANCE */
                accountType: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAccountPreferenceSettingResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getSettlementOrder: {
        parameters: {
            query: {
                requestId: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAccountTransferResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getReversalByRequestId: {
        parameters: {
            query: {
                requestId: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAccountReversalResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getPaymentByRequestId: {
        parameters: {
            query: {
                requestId: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAccountPaymentResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    configDetail: {
        parameters: {
            query: {
                id: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAccountOperationListConfigResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getRechargeRecommend: {
        parameters: {
            query: {
                id: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseRechargeRecommendResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    listCurrencys: {
        parameters: {
            query?: {
                currencyType?: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    listChannels: {
        parameters: {
            query: {
                currencyCode: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListChannelListResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getChannelLimit: {
        parameters: {
            query: {
                currencyCode: string;
                channelId: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseChannelLimitResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getAmounts: {
        parameters: {
            query: {
                currencyCode: string;
                channelId: number;
                count: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListInteger"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getCurrencys: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getTypes: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    deleteConfig: {
        parameters: {
            query: {
                id: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getAllViewCurrency: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListCurrencyViewVO"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getRecordTransactionRecordList: {
        parameters: {
            query?: {
                /** @description 币种 */
                currency?: string;
                /** @description 交易类型：TRANSFER, RECHARGE, WITHDRAW, BET_PLACED, BET_WON, BET_REFUNDED, BET_CANCELLED, CASH_OUT, SETTLEMENT_CANCELLED, VAULT_DEPOSIT, VAULT_WITHDRAW */
                type?: string;
                /** @description 币种类型：BALANCE、BONUS、CREDIT */
                source?: string;
                /** @description 开始时间 */
                startTime?: number;
                /** @description 结束时间 */
                endTime?: number;
                /** @description 页码 */
                pageNum?: number;
                /** @description 每页大小 */
                pageSize?: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResponseTransactionRecordResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getAccountRecommendList: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseRecommendResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    createWalletCreditRepay: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreditRepayRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCreditRepayResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getWalletCreditInfo: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCreditAccountInfoResult"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getCreditTransactionList: {
        parameters: {
            query?: {
                /** @description 页码 */
                pageNum?: number;
                /** @description 每页大小 */
                pageSize?: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResponseCreditTransactionRecordResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getWalletCreditBills: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListBillListResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getCreditBillDetail: {
        parameters: {
            query: {
                /** @description 账期 yyyy-MM */
                billPeriod: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListBillDetailResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getCreditTransactionDetail: {
        parameters: {
            query: {
                /** @description orderId */
                orderId: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseTransactionDetailResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getWalletCashierGetDepositCurrency: {
        parameters: {
            query: {
                /** @description 币种类型 0:法币 1:虚拟币 */
                currencyType: number;
                /** @description 最近成功最大条数 */
                maxNum?: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseDepositCurrencyResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getCashierCryptoGetWithdrawAddressByChain: {
        parameters: {
            query: {
                /** @description 币种 */
                currency: string;
                /** @description 链 */
                chain: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getWalletCashierGetWithdrawCurrency: {
        parameters: {
            query: {
                /** @description 币种类型 0:法币 1:虚拟币 */
                currencyType: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseWithdrawCurrencyResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    createTradeVaultWithdraw: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountVaultTransferRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    createTradeVaultDeposit: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountVaultTransferRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getAccountVaultRecords: {
        parameters: {
            query?: {
                /** @description 类型: VAULT_DEPOSIT, VAULT_WITHDRAW */
                type?: string;
                /** @description 开始时间 */
                startTime?: number;
                /** @description 结束时间 */
                endTime?: number;
                /** @description 页码 */
                pageNum?: number;
                /** @description 每页大小 */
                pageSize?: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResponseAccountVaultOrderResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getAccountConfigBetLimit: {
        parameters: {
            query?: {
                /** @description Credit account currency, default USDT */
                currencyCode?: string;
            };
            header?: {
                /**
                 * @description Client type /api All interfaces starting with will be restricted by gateway
                 *     Rules are as follows: [xx business]-[xx end]
                 *     BZ business:
                 *     1. Web end BZ-WEB
                 *     2. App end BZ-APP
                 *     3. Mini program end BZ-AAPLET
                 *     dev, test environment can use default value in swagger: SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAccountBetLimitConfigResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
}
export enum ApiPaths {
    recommendChange = "/api/wallet/manage/account/recommend/change",
    init = "/api/wallet/manage/account/init",
    add = "/api/wallet/currency/add",
    createWalletCashierWithdraw = "/api/wallet/cashier/withdraw",
    createWalletCashierDeposit = "/api/wallet/cashier/deposit",
    createCashierCryptoWithdraw = "/api/wallet/cashier/crypto/withdraw",
    createCashierCryptoCheckWithdrawParams = "/api/wallet/cashier/crypto/checkWithdrawParams",
    updateSetting = "/api/wallet/account/setting/update",
    transfer = "/api/account/trade/transfer",
    transferMerchant = "/api/account/trade/transfer/merchant",
    reversal = "/api/account/trade/reversal",
    payment = "/api/account/trade/payment",
    listTransfer = "/api/account/order/transfer/list",
    listPaymentOrder = "/api/account/order/payment/list",
    updateConfig = "/admin/wallet/operation-list/update",
    configList = "/admin/wallet/operation-list/list",
    addConfig = "/admin/wallet/operation-list/add",
    updateRechargeRecommend = "/admin/wallet/currency/recharge/recommend/update",
    openRechargeRecommend = "/admin/wallet/currency/recharge/recommend/open",
    listRechargeRecommends = "/admin/wallet/currency/recharge/recommend/list",
    deleteRechargeRecommend = "/admin/wallet/currency/recharge/recommend/delete",
    createRechargeRecommend = "/admin/wallet/currency/recharge/recommend/create",
    closeRechargeRecommend = "/admin/wallet/currency/recharge/recommend/close",
    orderList = "/admin/wallet/cashier/list",
    transactionList = "/admin/wallet/account/transaction/list",
    accountList = "/admin/wallet/account/list",
    frozenOrUnFrozen = "/admin/wallet/account/freezeOrUnFreeze",
    getWalletTokenGetTokensByCurrency = "/api/wallet/token/getTokensByCurrency",
    recommend = "/api/wallet/manage/account/recommend",
    recommendConfig = "/api/wallet/manage/account/recommend/config",
    info = "/api/wallet/manage/account/info",
    balance = "/api/wallet/manage/account/balance",
    getView = "/api/wallet/currency/view",
    getRealTimeExchangeRate = "/api/wallet/currency/getRealTimeExchangeRate",
    getExchangeRate = "/api/wallet/currency/getExchangeRate",
    getAllCurrency = "/api/wallet/currency/getAllCurrency",
    getWalletCashierGetWithdrawOrder = "/api/wallet/cashier/getWithdrawOrder",
    getWithdrawOrders = "/api/wallet/cashier/getWithdrawOrderList",
    getWalletCashierGetWithdrawMethods = "/api/wallet/cashier/getWithdrawMethods",
    getWithdrawKycInfoList = "/api/wallet/cashier/getWithdrawKycInfoList",
    getWalletCashierGetWithdrawFee = "/api/wallet/cashier/getWithdrawFee",
    getLastUsedChannel = "/api/wallet/cashier/getLastUsedChannel",
    getLastUsedChannelAll = "/api/wallet/cashier/getLastUsedChannelAll",
    getWalletCashierGetDepositOrder = "/api/wallet/cashier/getDepositOrder",
    getDepositOrders = "/api/wallet/cashier/getDepositOrderList",
    getDepositMethodsByCurrency = "/api/wallet/cashier/getDepositMethods",
    getDepositKycInfoList = "/api/wallet/cashier/getDepositKycInfoList",
    getDepositChannelAmounts = "/api/wallet/cashier/getDepositChannelAmounts",
    getBcDepositOrder = "/api/wallet/cashier/getBcDepositOrder",
    getCashierCryptoGetWithdrawFee = "/api/wallet/cashier/crypto/getWithdrawFee",
    getDepositAddressByChain = "/api/wallet/cashier/crypto/getDepositAddressByChain",
    getSetting = "/api/wallet/account/setting/get",
    getSettlementOrder = "/api/account/trade/getSettlementOrder",
    getReversalByRequestId = "/api/account/trade/getReversalOrder",
    getPaymentByRequestId = "/api/account/trade/getPaymentOrder",
    configDetail = "/admin/wallet/operation-list/detail",
    getRechargeRecommend = "/admin/wallet/currency/recharge/recommend/get",
    listCurrencys = "/admin/wallet/currency/list",
    listChannels = "/admin/wallet/currency/channel/list",
    getChannelLimit = "/admin/wallet/currency/channel/limit",
    getAmounts = "/admin/wallet/currency/channel/amounts",
    getCurrencys = "/admin/wallet/cashier/currencys",
    getTypes = "/admin/wallet/account/types",
    deleteConfig = "/admin/wallet/operation-list/delete",
    getAllViewCurrency = "/api/wallet/currency/getAllViewCurrency",
    getRecordTransactionRecordList = "/api/wallet/record/transactionRecord/list",
    getAccountRecommendList = "/api/wallet/manage/account/recommend/list",
    createWalletCreditRepay = "/api/wallet/credit/repay",
    getWalletCreditInfo = "/api/wallet/credit/info",
    getCreditTransactionList = "/api/wallet/credit/transaction/list",
    getWalletCreditBills = "/api/wallet/credit/bills",
    getCreditBillDetail = "/api/wallet/credit/bill/detail",
    getCreditTransactionDetail = "/api/wallet/credit/transaction/detail",
    getWalletCashierGetDepositCurrency = "/api/wallet/cashier/getDepositCurrency",
    getCashierCryptoGetWithdrawAddressByChain = "/api/wallet/cashier/crypto/getWithdrawAddressByChain",
    getWalletCashierGetWithdrawCurrency = "/api/wallet/cashier/getWithdrawCurrency",
    createTradeVaultWithdraw = "/api/wallet/trade/vault/withdraw",
    createTradeVaultDeposit = "/api/wallet/trade/vault/deposit",
    getAccountVaultRecords = "/api/wallet/manage/account/vault/records",
    getAccountConfigBetLimit = "/api/wallet/account/config/bet-limit"
}
